<template>
  <div class="layout-no-sidebar">
    <div class="layout-no-sidebar__body">
      <Header />
      <Preloader v-if="isStorageInfoLoading" />
      <main class="layout-no-sidebar__main" v-else>
        <div class="layout-no-sidebar__wrapper">
          <slot />
        </div>
      </main>
    </div>
    <Footer />
  </div>
</template>

<script>
import Header from "@/components/LayoutSection/Header.vue";
import Footer from "@/components/LayoutSection/Footer.vue";
import { mapState } from "vuex";
import Preloader from "@/components/Blocks/Preloader.vue";
export default {
  name: "LayoutNoSidebar",
  components: { Preloader, Footer, Header },
  computed: {
    ...mapState(["isStorageInfoLoading"]),
  },
};
</script>

<style lang="scss">
.layout-no-sidebar {
  min-height: 100vh;
  color: var(--text--color);
  font-size: 1.6rem;
  line-height: 2.24rem;
  font-weight: 400;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  &__body {
    flex-grow: 1;
    display: flex;
    flex-direction: column;
    min-height: 200px;
  }
  &__main {
    max-width: 1560px;
    width: 100%;
    margin: 0 auto;
    padding: 80px 20px;
    //box-sizing: content-box;
    @include adaptive(tablet-big) {
      padding-top: 30px;
    }
    @include adaptive(phone) {
      padding-top: 20px;
    }
  }
  .preloader {
    margin: auto;
  }
}
</style>
